import React from 'react';
import reactElementToJSXString from 'react-element-to-jsx-string';
import * as shp from 'shpjs';

import M from 'utils/Mapea';
import Utils from 'utils/Utils';
import LocalStorage from 'utils/LocalStorage';

const EDITION_COLOR = '#FFCC33';
const PROJECTION = 'EPSG:25830';
declare var ol;
declare var loadshp;
declare var CONFIGURATIONS;

export let mapjs;
export let mapInfojs;
let translate;
let select;

export const initCompareMap = (container, url, layerName, center, addPlugins, extent) => {
  let mapCompare = undefined;
  if (extent.length > 2) {
    mapCompare = M.map({
      container: container,
      bbox: extent,
      resolutions: [6433.863492239467, 3216.9317461197334, 1608.4658730598667,
        804.2329365299333, 402.11646826496667, 201.05823413248334, 100.52911706624167,
        50.264558533120834, 25.132279266560417, 12.566139633280208, 6.283069816640104,
        3.141534908320052, 1.570767454160026, 0.785383727080013,
        0.3926918635400065, 0.19634593177000326, 0.09817296588500163, 0.049086482942500815,
      ],
      layers: [new M.layer.WMS({
        name: 'CDAU_base,CDAU_toponimia',
        url: 'https://www.callejerodeandalucia.es/servicios/base/wms?',
        legend: 'Callejero Andaluc�a',
        transparent: false,
        tiled: true,
        version: '1.3.0',
      })],
      projection: 'EPSG:25830*m',
    });
  } else {
    mapCompare = M.map({
      container: container,
      center: center,
      resolutions: [6433.863492239467, 3216.9317461197334, 1608.4658730598667,
        804.2329365299333, 402.11646826496667, 201.05823413248334, 100.52911706624167,
        50.264558533120834, 25.132279266560417, 12.566139633280208, 6.283069816640104,
        3.141534908320052, 1.570767454160026, 0.785383727080013,
        0.3926918635400065, 0.19634593177000326, 0.09817296588500163, 0.049086482942500815,
      ],
      layers: [new M.layer.WMS({
        name: 'CDAU_base,CDAU_toponimia',
        url: 'https://www.callejerodeandalucia.es/servicios/base/wms?',
        legend: 'Callejero Andaluc�a',
        transparent: false,
        tiled: true,
        version: '1.3.0',
      })],
      projection: 'EPSG:25830*m',
      zoom: 8,
    });
  }

  mapCompare.removeControls('panzoom');
  if (addPlugins || true) {
    mapCompare.addPlugin(new M.plugin.Measurebar({}));
    mapCompare.addPlugin(new M.plugin.GeometryDraw({ position: 'TL' }));
  }

  addCustomWMSLayerComparator(mapCompare, url, layerName);
  return mapCompare.getMapImpl();
}

export const initMap = (flight, features, fullFeatures, updateFeatures, unblock, t) => {
  const lang = LocalStorage.getString('language') || 'es';
  M.language.setLang(lang);

  mapjs = M.map({
    container: 'map',
    center: [357267.5858747843, 4152273.4359555594],
    resolutions: [6433.863492239467, 3216.9317461197334, 1608.4658730598667,
      804.2329365299333, 402.11646826496667, 201.05823413248334, 100.52911706624167,
      50.264558533120834, 25.132279266560417, 12.566139633280208, 6.283069816640104,
      3.141534908320052, 1.570767454160026, 0.785383727080013,
      0.3926918635400065, 0.19634593177000326, 0.09817296588500163, 0.049086482942500815,
    ],
    controls: ['getfeatureinfo', 'scaleline', 'scale', 'rotate'],
    layers: [new M.layer.WMS({
      name: 'CDAU_base,CDAU_toponimia',
      url: 'https://www.callejerodeandalucia.es/servicios/base/wms?',
      legend: 'Callejero Andaluc�a',
      transparent: false,
      tiled: true,
      version: '1.3.0',
    })],
    projection: 'EPSG:25830*m',
    zoom: 4,
    minZoom: 4,
  });

  window.mapjs = mapjs;
  mapjs.getMapImpl().on('click', (evt) => {
    removeMapOverlays();
    if (flight() !== undefined) {
      mapjs.getMapImpl().forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        let newSelected = [].concat(features());
        let newFullSelected = [].concat(fullFeatures());
        // layer !== null && Utils.stringContainsString(feature.getGeometry().getType(), 'Point') && feature.getProperties().features[0].getProperties()[CONFIGURATIONS.fotogram_layer_attr] !== undefined
        if (layer !== null && Utils.stringContainsString(feature.getGeometry().getType(), 'Point') && feature.getProperties()[CONFIGURATIONS.fotogram_layer_attr] !== undefined) {
          // const ID = feature.getProperties().features[0].getProperties()[CONFIGURATIONS.fotogram_layer_attr];
          const ID = feature.getProperties()[CONFIGURATIONS.fotogram_layer_attr];
          if (newSelected.indexOf(ID) < 0) {
            newSelected.push(ID);
            // newFullSelected.push({ properties: feature.getProperties().features[0].getProperties() });
            newFullSelected.push({ properties: feature.getProperties() });
          } else {
            newSelected = [].concat(newSelected.filter((item) => {
              if (item === ID) {
                removeCustomWMSLayer(ID);
              }

              return item !== ID;
            }));

            newFullSelected = [].concat(newFullSelected.filter((item) => {
              return item.properties.fotogramas !== ID;
            }));
          }

          updateFeatures(newSelected, newFullSelected, true);
        }
      });
    }
  });

  mapjs.getMapImpl().on('pointermove', (evt) => {
    if (flight() !== undefined) {
      const marks = mapjs.getLayers().filter((layer) => layer.name === CONFIGURATIONS.marks_name)[0];
      if (marks !== null && marks !== undefined) {
        marks.getFeatures().forEach((f) => {
          f.setStyle(new M.style.Polygon({
            fill: {
              color: '#0041ff',
              opacity: 0,
            },
          }));
        });
      }

      mapjs.getMapImpl().forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        if (marks !== null && marks !== undefined) {
          if (Utils.stringContainsString(feature.getGeometry().getType(), 'point')) {
            marks.getFeatures().forEach((f) => {
              // f.getAttribute(CONFIGURATIONS.marks_layer_attr) !== undefined && feature.getProperties().features !== undefined
              if (f.getAttribute(CONFIGURATIONS.marks_layer_attr) !== undefined) {
                // f.getAttribute(CONFIGURATIONS.marks_layer_attr) === feature.getProperties().features[0].getProperties()[CONFIGURATIONS.fotogram_layer_attr]
                if (f.getAttribute(CONFIGURATIONS.marks_layer_attr) === feature.getProperties()[CONFIGURATIONS.fotogram_layer_attr]) {
                  f.setStyle(new M.style.Polygon({
                    stroke: {
                      width: 2,
                      color: '#E74C3C',
                    },
                  }));

                  showInfoPopup(feature, t);
                } else {
                  f.setStyle(new M.style.Polygon({
                    fill: {
                      color: '#0041ff',
                      opacity: 0,
                    },
                  }));
                }
              }
            });
          } else {
            removeMapOverlays();
          }
        }
      });
    }
  });

  mapjs.getMapImpl().once('postrender', (evt) => {
    mapjs.removeControls('panzoom');
    unblock();
  });

  mapjs.addPlugin(getConfiguredBaseLayersPlugin(t));
  mapjs.addPlugin(new M.plugin.Measurebar({}));
  mapjs.addPlugin(new M.plugin.GeometryDraw({ position: 'TL' }));
  mapjs.addPlugin(new M.plugin.ShowCoordinates({ position: 'TL' }));
  mapjs.addPlugin(new M.plugin.ThreeMapea());
  mapjs.addPlugin(new M.plugin.ZoomPanel({
    position: 'TL',
    collapsed: true,
    center: [357267.5858747843, 4152273.4359555594],
    zoom: 4,
  }));

  mapjs.addPlugin(new M.plugin.OverviewMap({
    position: 'BR',
    fixed: true,
    zoom: 4,
    baseLayer: CONFIGURATIONS.overviewmap_layer,
  }, { collapsed: true, collapsible: true }));

  mapjs.addPlugin(new M.plugin.PrinterMap({
    position: 'TR',
  }));

  mapjs.addPlugin(new M.plugin.SearchPanel({
    position: 'TL',
    pointZoom: 12,
    collapsed: true,
    collapsible: true,
  }));

  mapjs.addPlugin(new M.plugin.Rescale({
    collapsible: true,
    collapsed: true,
    position: 'TL',
  }));

  mapjs.addPlugin(new M.plugin.ShareMap({
    baseUrl: 'https://mapea4-sigc.juntadeandalucia.es/mapea/',
    position: 'BL',
  }));

  mapjs.addPlugin(new M.plugin.Transparency({
    position: 'TR',
    layers: CONFIGURATIONS.transparency_layers,
  }));

  const drawLayer = new M.layer.Vector({
    name: 'drawLayer',
    legend: 'drawLayer',
    extract: false,
  });

  setTimeout(() => {
    M.proxy(false);
    const path = window.location.hostname.indexOf('localhost') === -1 ? (window.location.protocol + '//' + window.location.hostname) : 'http://fototeca-desarrollo.desarrollo.guadaltel.es';
    mapjs.addPlugin(new M.plugin.Popup({
      position: 'BR',
      collapsed: true,
      //url_es: `${path}/fototeca/attributions_es.html`,
      //url_en: `${path}/fototeca/attributions_en.html`,
      url_es: `${path}/institutodeestadisticaycartografia/fototeca/attributions_es.html`,
      url_en: `${path}/institutodeestadisticaycartografia/fototeca/attributions_en.html`,
    }));

    mapjs.addLayers([drawLayer]);
    setTimeout(() => {
      M.proxy(true);
      drawLayer.setZIndex(999999999);
    }, 100);

    document.querySelector('.m-panel.m-rotate #m-rotate-slider-container').setAttribute('title', t('visor.rotate'));
    document.querySelector('.m-panel.m-scaleline').setAttribute('title', t('visor.scaleline'));
    document.querySelector('.m-panel.m-tools').setAttribute('title', t('visor.tools_panel'));
    document.querySelector('.m-panel.m-tools .m-measurelength-container #m-measure-button').setAttribute('title', t('visor.lengths'));
    document.querySelector('.m-panel.m-tools .m-measurearea-container #m-measure-button').setAttribute('title', t('visor.areas'));
    document.querySelector('.m-panel.m-tools .m-measureclear-container #m-measure-button').setAttribute('title', t('visor.delete_measures'));
    document.querySelector('.m-panel.m-tools .m-getfeatureinfo-container button').setAttribute('title', t('visor.information'));
  }, 500);
};

export const isLoadedMap = () => mapjs !== undefined;

export const getScale = () => {
  return mapjs.getScale();
}

export const getZoom = () => {
  return mapjs.getZoom();
}

export const getBbox = () => {
  const bbox = mapjs.getBbox();
  return [bbox.x.min, bbox.y.min, bbox.x.max, bbox.y.max];
}

export const setBbox = (extent) => {
  mapjs.setBbox(extent);
}

export const setBboxTransform = (coordinates) => {
  mapjs.setBbox(ol.proj.transformExtent(new ol.geom.Polygon(coordinates).getExtent(), 'EPSG:4326', PROJECTION));
}

export const toLonLat = (coords) => {
  return ol.proj.toLonLat(coords, PROJECTION);
}

export const extentIntersectsBbox = (extent) => {
  return ol.extent.intersects(getBbox(), extent);
}

export const getExtentByCoordinates = (geometry) => {
  let extent = [];
  if (geometry.type === 'Polygon') {
    extent = ol.proj.transformExtent(new ol.geom.Polygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  } else {
    extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  }

  return extent;
}

export const getCenterOfGeometry = (geometry) => {
  let extent = [];
  if (geometry.type === 'Polygon') {
    extent = ol.proj.transformExtent(new ol.geom.Polygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  } else {
    extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  }

  return ol.extent.getCenter(extent);
}

export const openInfoDialog = (text) => {
   M.dialog.info(text);
}

export const addWMSLayer = (name, legend, url, version, tiled, options) => {
  const args = {
    name: name,
    url: url,
    legend: legend,
    transparent: true,
    tiled: tiled,
    version: version,
  };

  const layer = new M.layer.WMS(args, options);
  if (options && options.hasOwnProperty('visibility')) {
    layer.setVisible(options.visibility);
  }

  if (options && options.hasOwnProperty('displayInLayerSwitcher')) {
    layer.displayInLayerSwitcher = options.displayInLayerSwitcher;
  }

  if (options && options.hasOwnProperty('zIndex')) {
    layer.setZIndex(options.zIndex);
  }

  mapjs.addLayers(layer);
  return layer.getImpl().getExtent();
};

export const addCustomWMSLayer = (url, fotogram, unblock) => {
  if (!isCustomWMSLayerActive(fotogram)) {
    const tileGrid = new ol.tilegrid.TileGrid({
      extent: mapjs.getImpl().getMapImpl().getView().calculateExtent(),
      resolutions: mapjs.getResolutions()
    });

    const source = new ol.source.TileWMS({
      url: url,
      params: {
        LAYERS: CONFIGURATIONS.layer_name,
        FORMAT: 'image/png',
        VERSION: '1.1.0',
        TRANSPARENT: true,
        TILED: true,
        fotograma: fotogram,
      },
      serverType: 'mapserver',
      tileGrid: tileGrid,
    });

    const layer = new ol.layer.Tile({
      visible: true,
      opacity: 1,
      zIndex: 999,
      source: source,
    });

    mapjs.getMapImpl().addLayer(layer);
    if (unblock !== undefined) {
      source.once('tileloadend', (evt) => {
        unblock();
      });

      source.once('tileloaderror', (evt) => {
        unblock();
      });
    }
  }
}

export const addCustomWMSLayerComparator = (map, url, fotogram) => {

  const tileGrid = new ol.tilegrid.TileGrid({
    extent: mapjs.getImpl().getMapImpl().getView().calculateExtent(),
    resolutions: mapjs.getResolutions()
  });

  const source = new ol.source.TileWMS({
    url: url,
    params: {
      LAYERS: CONFIGURATIONS.layer_name,
      FORMAT: 'image/png',
      VERSION: '1.1.0',
      TILED: true,
      TRANSPARENT: true,
      fotograma: fotogram,
    },
    serverType: 'mapserver',
    tileGrid: tileGrid,
  });

  const layer = new ol.layer.Tile({
    visible: true,
    opacity: 1,
    zIndex: 999,
    source: source,
  });

  map.getMapImpl().addLayer(layer);
}

export const isCustomWMSLayerActive = (fotogram) => {
  let res = false;
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.type === 'TILE' && layer.getSource().params_ !== undefined && layer.getSource().getParams()['fotograma'] === fotogram;
  });

  res =  res || filtered.length > 0;
  return res;
}

export const setCustomWMSLayerOpacity = (fotogram, newOpacity) => {
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.type === 'TILE' && layer.getSource().params_ !== undefined && layer.getSource().getParams()['fotograma'] === fotogram;
  });

  filtered[0].setOpacity(newOpacity);
}

export const getCustomWMSLayerOpacity = (fotogram) => {
  let res = 0;
  const filtered = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.type === 'TILE' && layer.getSource().params_ !== undefined && layer.getSource().getParams()['fotograma'] === fotogram;
  });

  if (filtered.length > 0) {
    res = filtered[0].getOpacity();;
  }

  return res;
}

export const removeCustomWMSLayer = (fotogram) => {
  const toDelete = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.type === 'TILE' && layer.getSource().params_ !== undefined && layer.getSource().getParams()['fotograma'] === fotogram;
  });

  if (toDelete.length > 0) {
    mapjs.getMapImpl().removeLayer(toDelete[0]);
  }
}

export const removeAllCustomWMSLayer = () => {
  const toDelete = mapjs.getMapImpl().getLayers().getArray().filter((layer) => {
    return layer.type === 'TILE' && layer.getSource().params_ !== undefined && layer.getSource().getParams()['LAYERS'] !== undefined && layer.getSource().urls.length > 0 && layer.getSource().urls[0].indexOf(CONFIGURATIONS.services_url) > -1;
  });

  if (toDelete.length > 0) {
    toDelete.forEach((del) => {
      mapjs.getMapImpl().removeLayer(del);
    });
  }
}

export const centerOnFotogram = (id, coordinates) => {
  const coord = ol.proj.fromLonLat(coordinates, PROJECTION);
  mapjs.setCenter(coord);
  mapjs.setZoom(CONFIGURATIONS.fotograms_zoom + 2);
}

export const newGeoJSONLayer = (args, options) => {
  return new M.layer.GeoJSON(args, options || {});
}

export const addFlightLayers = (coverage, centers, marks, getSelectedFeatures, unblock) => {
  removeMapOverlays();
  const zoom = mapjs.getZoom();
  const sourceCenters = Object.assign({}, centers.source);
  const sourceMarks = Object.assign({}, marks.source);
  mapjs.getMapImpl().removeEventListener('moveend');
  if (mapjs.getScale() > CONFIGURATIONS.tools_min_scale) {
    const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
    for (let interaction of arrayInteractions) {
      if (interaction instanceof ol.interaction.Draw) {
        if (interaction.getOverlay().getLayersArray().length > 0) {
          try {
            const color = interaction.getOverlay().getLayersArray()[0].getStyle().getStroke().getColor();
            if (Utils.compareStrings(color, EDITION_COLOR) === 0) {
              document.getElementById('drawPolygon').click();
              break;
            }
          } catch (err) {}
        }
      }
    }
  }

  if (zoom >= CONFIGURATIONS.min_zoom && zoom <= CONFIGURATIONS.fotograms_zoom - 1) {
    if (!mapContainsLayer(coverage.name)) {
      mapjs.addLayers(coverage);
      coverage.setZIndex(999999999999999999);
      coverage.setStyle(new M.style.Polygon({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          width: 2,
          color: '#0041ff',
        },
      }));
    }
  } else {
    try {
      mapjs.removeLayers([coverage]);
    } catch (err) {}
  }

  if (zoom >= CONFIGURATIONS.fotograms_zoom && zoom <= CONFIGURATIONS.max_zoom) {
    mapjs.removeLayers([centers, marks]);
    const centersFeatures = sourceCenters.features.filter((f) => {
      return f.geometry !== null && ol.extent.containsCoordinate(getBbox(), ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION));
    });

    const marksFeatures = sourceMarks.features.filter((f) => {
      let extent = [];
      if (f.geometry !== null && f.geometry.type === 'Polygon') {
        extent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      } else if (f.geometry !== null) {
        extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      }

      return ol.extent.intersects(getBbox(), extent);
    });

    centers = newGeoJSONLayer({ source: Object.assign({}, sourceCenters), name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
    marks = newGeoJSONLayer({ source: Object.assign({}, sourceMarks), name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
    centers.source.features = centersFeatures;
    marks.source.features = marksFeatures;
    mapjs.addLayers(centers);
    mapjs.addLayers(marks);
    centers.setZIndex(999999999999999999);
    marks.setZIndex(999999999999999999);

    /* const clusterStyle = new M.style.Cluster({
      ranges: [
        {
          min: 2,
          max: centers.source.features.length + 1,
          style: new M.style.Point({
            fill: {
              color: '#0041ff',
              opacity: 0.6,
            },
            stroke: {
              width: 2,
              color: '#0041ff',
            },
            radius: 15,
          }),
        }
      ],
      animated: true,
      hoverInteraction: false,
      displayAmount: true,
      selectInteraction: false,
      distance: CONFIGURATIONS.distance_cluster,
    }, { displayInLayerSwitcherHoverLayer: false });

    const pointStyle = new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    });

    clusterStyle.add(pointStyle);
    centers.setStyle(clusterStyle);*/

    const pointStyle = new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    });

    centers.setStyle(pointStyle);

    marks.setStyle(new M.style.Polygon({
      fill: {
        color: '#0041ff',
        opacity: 0,
      },
    }));

    setTimeout(() => {
      centers.getFeatures().forEach((f) => {
        const selectedFeatures = getSelectedFeatures();
        if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_layer_attr)) > -1) {
          f.setStyle(new M.style.Point({
            fill: {
              color: '#E74C3C',
              opacity: 0.6,
            },
            stroke: {
              color: '#E74C3C',
              width: 2,
            },
            radius: 7,
          }));
        }
      });
    }, CONFIGURATIONS.highlight_selected_timeout);
  } else {
    try {
      mapjs.removeLayers([centers, marks]);
    } catch (err) {}
  }

  mapjs.getMapImpl().on('moveend', () => {
    const zoom = mapjs.getZoom();
    if (mapjs.getScale() > CONFIGURATIONS.tools_min_scale) {
      const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
      for (let interaction of arrayInteractions) {
        if (interaction instanceof ol.interaction.Draw) {
          if (interaction.getOverlay().getLayersArray().length > 0) {
            try {
              const color = interaction.getOverlay().getLayersArray()[0].getStyle().getStroke().getColor();
              if (Utils.compareStrings(color, EDITION_COLOR) === 0) {
                document.getElementById('drawPolygon').click();
                break;
              }
            } catch (err) {}
          }
        }
      }
    }

    if (zoom >= CONFIGURATIONS.min_zoom && zoom <= CONFIGURATIONS.fotograms_zoom - 1) {
      removeMapOverlays();
      if (!mapContainsLayer(coverage.name)) {
        mapjs.addLayers(coverage);
        coverage.setZIndex(999999999999999999);
        coverage.setStyle(new M.style.Polygon({
          fill: {
            color: '#0041ff',
            opacity: 0.6,
          },
          stroke: {
            width: 2,
            color: '#0041ff',
          },
        }));
      }
    } else {
      try {
        mapjs.removeLayers([coverage]);
      } catch (err) {}
    }

    if (zoom >= CONFIGURATIONS.fotograms_zoom && zoom <= CONFIGURATIONS.max_zoom) {
      mapjs.removeLayers([centers, marks]);
      const centersFeatures = sourceCenters.features.filter((f) => {
        return f.geometry !== null && ol.extent.containsCoordinate(getBbox(), ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION));
      });

      const marksFeatures = sourceMarks.features.filter((f) => {
        let extent = [];
        if (f.geometry !== null && f.geometry.type === 'Polygon') {
          extent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
        } else if (f.geometry !== null) {
          extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
        }

        return ol.extent.intersects(getBbox(), extent);
      });

      centers = newGeoJSONLayer({ source: Object.assign({}, sourceCenters), name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
      marks = newGeoJSONLayer({ source: Object.assign({}, sourceMarks), name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
      centers.source.features = centersFeatures;
      marks.source.features = marksFeatures;
      mapjs.addLayers(centers);
      mapjs.addLayers(marks);
      centers.setZIndex(999999999999999999);
      marks.setZIndex(999999999999999999);

      /* const clusterStyle = new M.style.Cluster({
        ranges: [
          {
            min: 2,
            max: centers.source.features.length + 1,
            style: new M.style.Point({
              fill: {
                color: '#0041ff',
                opacity: 0.6,
              },
              stroke: {
                width: 2,
                color: '#0041ff',
              },
              radius: 15,
            }),
          }
        ],
        animated: true,
        hoverInteraction: false,
        displayAmount: true,
        selectInteraction: false,
        distance: CONFIGURATIONS.distance_cluster,
      }, { displayInLayerSwitcherHoverLayer: false });

      const pointStyle = new M.style.Point({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          width: 2,
          color: '#0041ff',
        },
        radius: 7,
      });

      clusterStyle.add(pointStyle);
      centers.setStyle(clusterStyle);*/

      const pointStyle = new M.style.Point({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          width: 2,
          color: '#0041ff',
        },
        radius: 7,
      });

      centers.setStyle(pointStyle);

      marks.setStyle(new M.style.Polygon({
        fill: {
          color: '#0041ff',
          opacity: 0,
        },
      }));

      setTimeout(() => {
        centers.getFeatures().forEach((f) => {
          const selectedFeatures = getSelectedFeatures();
          if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_layer_attr)) > -1) {
            f.setStyle(new M.style.Point({
              fill: {
                color: '#E74C3C',
                opacity: 0.6,
              },
              stroke: {
                color: '#E74C3C',
                width: 2,
              },
              radius: 7,
            }));
          }
        });
      }, CONFIGURATIONS.highlight_selected_timeout);
    } else {
      try {
        mapjs.removeLayers([centers, marks]);
      } catch (err) {}
    }
  });

  mapjs.getMapImpl().once('postrender', (evt) => {
    unblock();
  });
}

export const addGeoJSONLayer = (args, options, geom, center, isMTN) => {
  const layer = new M.layer.GeoJSON(args, options || {});
  mapjs.addLayers(layer);
  if (Utils.stringContainsString(geom, 'Line')) {
    layer.setStyle(new M.style.Line({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
    }));
  } else if (Utils.stringContainsString(geom, 'Point')) {
    layer.setStyle(new M.style.Point({
      fill: {
        color: '#0041ff',
        opacity: 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
      radius: 7,
    }));
  } else if (Utils.stringContainsString(geom, 'Polygon')) {
    layer.setStyle(new M.style.Polygon({
      fill: {
        color: '#0041ff',
        opacity: isMTN ? 0.2 : 0.6,
      },
      stroke: {
        width: 2,
        color: '#0041ff',
      },
    }));
  }

  if (center) {
    setTimeout(() => {
      mapjs.setBbox(layer.getMaxExtent());
    }, CONFIGURATIONS.layer_added_timeout);
  }

  layer.setZIndex(999999999999999999);
  return layer;
};

export const removeUploadedLayers = () => {
  let layerRes = mapjs.getLayers().filter((layer) => (layer.name.startsWith('uploadedLayer') || layer.name.startsWith('Hoja ')));
  if (layerRes && layerRes.length > 0) {
    return mapjs.removeLayers(layerRes);
  }

  return false;
};

export const mapContainsLayer = (layerName) => {
  let layerRes = mapjs.getLayers().filter((layer) => (layer.name === layerName));
  return layerRes && layerRes.length > 0;
}

export const removeAllFlightLayers = () => {
  mapjs.getMapImpl().removeEventListener('moveend');
  clearDrawLayer();
  removeAllCustomWMSLayer();
  const names = [CONFIGURATIONS.coverage_name, CONFIGURATIONS.centers_name, CONFIGURATIONS.marks_name];
  let layerRes = mapjs.getLayers().filter((layer) => {
    let res = false;
    names.forEach((name) => {
      res = res || layer.name.indexOf(name) > -1;
    });

    return res;
  });

  mapjs.getMapImpl().on('moveend', () => {
    if (mapjs.getScale() > CONFIGURATIONS.tools_min_scale) {
      const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
      for (let interaction of arrayInteractions) {
        if (interaction instanceof ol.interaction.Draw) {
          if (interaction.getOverlay().getLayersArray().length > 0) {
            try {
              const color = interaction.getOverlay().getLayersArray()[0].getStyle().getStroke().getColor();
              if (Utils.compareStrings(color, EDITION_COLOR) === 0) {
                document.getElementById('drawPolygon').click();
                break;
              }
            } catch (err) {}
          }
        }
      }
    }
  });

  if (layerRes && layerRes.length > 0) {
    return mapjs.removeLayers(layerRes);
  }

  return false;
}

export const drawPolygon = (loadFeatures) => {
  removeDrawInteraction();
  clearDrawLayer();
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  const draw = new ol.interaction.Draw({
    source: drawLayer.getImpl().getOL3Layer().getSource(),
    type: 'Polygon',
    stopClick: true,
    style: new ol.style.Style({
      image: new ol.style.Circle({
          fill: new ol.style.Fill({
              color: '#478ffe',
          }),
          stroke: new ol.style.Stroke({
              width: 3,
              color: '#ffffff',
          }),
          radius: 6,
      }),
      fill: new ol.style.Fill({
        color: 'rgba(255, 255, 255, 0.5)'
      }),
      stroke: new ol.style.Stroke({
        color: EDITION_COLOR,
        width: 2,
      }),
    }),
  });

  mapjs.getMapImpl().addInteraction(draw);
  document.getElementById('map').style.cursor = 'crosshair';
  draw.once('drawend', (evt) => {
    setTimeout(() => {
      document.getElementById('map').style.cursor = 'default';
      loadFeatures();
      removeDrawInteraction();
    }, 100);
  });

  draw.once('drawstart', (evt) => {
    document.addEventListener('keydown', controlDrawWithKeyboard.bind(null, draw));
  });
}

export const hasDrawFeatures = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.getImpl().getOL3Layer().getSource().getFeatures().length > 0;
}

export const clearDrawLayer = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.clear();
}

export const getDrawnFeatures = () => {
  const drawLayer = mapjs.getLayers().filter((layer) => (layer.type === 'Vector' && layer.name === 'drawLayer'))[0];
  return drawLayer.getImpl().getOL3Layer().getSource().getFeatures();
}

export const getUploadedLayer = () => {
  return mapjs.getLayers().filter((layer) => layer.name.startsWith('uploadedLayer'))[0];
}

export const removeDrawInteraction = () => {
  document.releaseEvents(Event.KEYDOWN);
  const arrayInteractions = [].concat(mapjs.getMapImpl().getInteractions().getArray());
  arrayInteractions.forEach((interaction) => {
    if (interaction instanceof ol.interaction.Draw || interaction instanceof ol.interaction.Modify) {
      mapjs.getMapImpl().removeInteraction(interaction);
    }
  });
}

export const isLayerIntersectingExtent = (layer, extent) => {
  let intersecting = false;
  for (let f of layer.features) {
    if (f.geometry.type === 'Point') {
      if (ol.extent.containsCoordinate(extent, ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting = true;
        break;
      }
    } else if (f.geometry.type === 'Polygon') {
      const geom = new ol.geom.Polygon(f.geometry.coordinates);
      geom.transform('EPSG:4326', PROJECTION);
      if (geom.intersectsExtent(extent)) {
        intersecting = true;
        break;
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const geom = new ol.geom.MultiPolygon(f.geometry.coordinates);
      geom.transform('EPSG:4326', PROJECTION);
      if (geom.intersectsExtent(extent)) {
        intersecting = true;
        break;
      }
    }
  }

  return intersecting;
}

export const getFeaturesIntersectingExtent = (features, extent) => {
  let intersecting = [];
  features.forEach((f) => {
    if (f.geometry.type === 'Point') {
      if (ol.extent.containsCoordinate(extent, ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'Polygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(extent, featureExtent)) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(extent, featureExtent)) {
        intersecting.push(f);
      }
    }
  });

  return intersecting;
}

export const getFeaturesIntersectingGeometry = (features, geometry) => {
  let intersecting = [];
  features.forEach((f) => {
    if (f.geometry.type === 'Point') {
      if (geometry.getGeometry().intersectsCoordinate(ol.proj.fromLonLat(f.geometry.coordinates, PROJECTION))) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'Polygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.Polygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(geometry.getGeometry().getExtent(), featureExtent)) {
        intersecting.push(f);
      }
    } else if (f.geometry.type === 'MultiPolygon') {
      const featureExtent = ol.proj.transformExtent(new ol.geom.MultiPolygon(f.geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
      if (ol.extent.intersects(geometry.getGeometry().getExtent(), featureExtent)) {
        intersecting.push(f);
      }
    }
  });

  return intersecting;
}

export const addLayerFile = (file, block, unblock, t) => {
  block();
  const fileReader = new FileReader();
  fileReader.addEventListener('load', (e) => {
    try {
      let features = [];
      if ((file.type === 'application/vnd.google-earth.kml+xml') || Utils.checkFileExtension(file, '.kml')) {
        features = loadKMLLayer(mapjs.getLayers().length, fileReader.result, false);
      } else if (Utils.checkFileExtension(file, '.geojson') || Utils.checkFileExtension(file, '.json')) {
        features = loadGeoJSONLayer(mapjs.getLayers().length, fileReader.result);
      } else if (Utils.checkFileExtension(file, '.gpx')) {
        features = loadGPXLayer(mapjs.getLayers().length, fileReader.result);
      } else if (Utils.checkFileExtension(file, '.zip')) {
        const geojsonArray = [].concat(shp.parseZip(fileReader.result));
        geojsonArray.forEach((geojson) => {
          const localFeatures = loadGeoJSONLayer(mapjs.getLayers().length, geojson);
          if (localFeatures) {
            features = features.concat(localFeatures);
          }
        });
      } else {
        unblock(true);
        M.dialog.error(t('visor.wrong_format'));
      }

      if (!features.length) {
        unblock(true);
        M.dialog.info(t('visor.no_geom'));
      } else {
        if (features.length > CONFIGURATIONS.num_features_allowed) {
          unblock(true);
          M.dialog.info(t('visor.max_allowed1') + ' ' + CONFIGURATIONS.num_features_allowed + ' ' + t('visor.max_allowed2'));
        } else {
          let area = 0;
          features.forEach((f) => {
            if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
              area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
            }
          });

          if (area > CONFIGURATIONS.max_area_allowed)  {
            unblock(true);
            M.dialog.info(t('visor.area_limit'));
          } else {
            centerFeatures(features);
            unblock(false);
          }
        }
      }
    } catch (err) {
      unblock(true);
      M.dialog.error(t('visor.error_loading'));
    }
  });


  if (Utils.checkFileExtension(file, '.zip')) {
    fileReader.readAsArrayBuffer(file);
  } else if (Utils.checkFileExtension(file, '.kml') || Utils.checkFileExtension(file, '.gpx') || Utils.checkFileExtension(file, '.geojson') || Utils.checkFileExtension(file, '.json')) {
    fileReader.readAsText(file);
  } else {
    unblock();
    M.dialog.error(t('visor.wrong_format'));
  }
}

export const highlightFeatures = (selectedFeatures) => {
  const allFeatures = getRenderedCenters();
  allFeatures.forEach((f) => {
    if (selectedFeatures.indexOf(f.getAttribute(CONFIGURATIONS.fotogram_layer_attr)) > -1) {
      f.setStyle(new M.style.Point({
        fill: {
          color: '#E74C3C',
          opacity: 0.6,
        },
        stroke: {
          color: '#E74C3C',
          width: 2,
        },
        radius: 7,
      }));
    } else {
      f.setStyle(new M.style.Point({
        fill: {
          color: '#0041ff',
          opacity: 0.6,
        },
        stroke: {
          color: '#0041ff',
          width: 2,
        },
        radius: 7,
      }));
    }
  });
}

export const selectPrintArea = (scale, center, size, extent, sendToPrint) => {
  center = ol.proj.fromLonLat(center, PROJECTION);
  const vectorSource = new ol.source.Vector({});
  const layer = new ol.layer.Vector({
      source: vectorSource,
      name: 'print_layer',
  });

  if (ol.extent.intersects(getBbox(), extent)) {
    const areaExtent = ol.extent.getArea(extent);
    const areaBbox = ol.extent.getArea(getBbox());
    if (areaExtent >= areaBbox) {
      center = ol.extent.getCenter(getBbox());
    } else {
      mapjs.setCenter(center);
      mapjs.setBbox(extent);
    }
  } else {
    mapjs.setCenter(center);
    mapjs.setBbox(extent);
  }

  mapjs.getMapImpl().addLayer(layer);
  const width = ((size[0]/100) * (scale))/2;
  const length = ((size[1]/100) * (scale))/2;
  const minX = center[0] - width;
  const minY = center[1] - length;
  const maxX = center[0] + width;
  const maxY = center[1] + length;
  const polygon = ol.geom.Polygon.fromExtent([minX, minY, maxX, maxY]);
  const feature = new ol.Feature({
    geometry: polygon,
    name: 'print_feature',
  });

  const style = new ol.style.Style({
    stroke: new ol.style.Stroke({ color: '#009999', width: 5 }),
    fill: new ol.style.Fill({ color: 'rgba(0, 153, 153, 0.3)' }),
  });

  feature.setStyle(style);
  layer.setZIndex(99999999999999999999);
  vectorSource.addFeature(feature);
  select = new ol.interaction.Select({
    filter: (feature) => {
      return (feature.getProperties() || {}).hasOwnProperty('name') && feature.getProperties().name === 'print_feature';
    },
  });

  translate = new ol.interaction.Translate({
    features: select.getFeatures(),
    layers: [layer],
  });

  select.on('select', (evt) => {
    const selected = evt.selected;
    if (selected.length > 0) {
      const style_modify = new ol.style.Style({
        stroke: new ol.style.Stroke({ color: '#ff0000', width: 5 }),
        fill: new ol.style.Fill({ color: 'rgba(255, 255, 255, 0.5)' }),
      });

      selected.forEach((feature) => {
        feature.setStyle(style_modify);
      });

      mapjs.getMapImpl().addInteraction(translate);
      translate.on('translateend', (evt) => {
        const bbox = evt.features.getArray()[0].getGeometry().getExtent();
        if (ol.extent.intersects(bbox, extent)) {
          document.releaseEvents(Event.KEYDOWN);
          sendToPrint(ol.extent.getCenter(bbox));
        } else {
          document.releaseEvents(Event.KEYDOWN);
          sendToPrint(null);
        }

        mapjs.getMapImpl().removeLayer(layer);
        mapjs.getMapImpl().removeInteraction(translate);
        mapjs.getMapImpl().removeInteraction(select);
      });

      document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape') {
          mapjs.getMapImpl().removeLayer(layer);
          mapjs.getMapImpl().removeInteraction(translate);
          mapjs.getMapImpl().removeInteraction(select);
        }
      });
    }
  });

  mapjs.getMapImpl().addInteraction(select);
  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape') {
      mapjs.getMapImpl().removeLayer(layer);
      mapjs.getMapImpl().removeInteraction(select);
    }
  });
}

export const clearPrintLayer = () => {
  const layers = mapjs.getMapImpl().getLayers().getArray().filter((l) => {
    return Utils.compareStrings(l.type, 'VECTOR') === 0 && l.getSource().getFeatures().length === 1 && l.values_.name === 'print_layer';
  });

  if (layers.length > 0) {
    mapjs.getMapImpl().removeLayer(layers[0]);
  }

  mapjs.getMapImpl().removeInteraction(translate);
  mapjs.getMapImpl().removeInteraction(select);
}

const getRenderedCenters = () => {
  let res = [];
  let layerRes = mapjs.getLayers().filter((layer) => {
    return layer.name.indexOf(CONFIGURATIONS.centers_name) > -1;
  });

  if (layerRes.length > 0) {
    res = layerRes[0].getFeatures();
  }

  return res;
}

export const getFeatureFromFotogram = (fotogram, centersLayer) => {
  let res = null;
  const allFeatures = centersLayer.source.features;
  const filtered = allFeatures.filter((f) => {
    return f.properties[CONFIGURATIONS.fotogram_layer_attr] === fotogram;
  });

  if (filtered.length > 0) {
    res = filtered[0];
  }

  return res;
}

const getConfiguredBaseLayersPlugin = (t) => {
  const layerOpts = [];
  CONFIGURATIONS.background_layers_config.layers.forEach((l) => {
    if (l.type === 'WMS') {
      layerOpts.push({
        id: l.id,
        preview: l.preview,
        title: l.title,
        layers: [
          new M.layer.WMS({
            url: l.url,
            name: l.name,
            legend: l.title,
            transparent: false,
            visible: true,
            format: l.format,
            version: l.version,
          }),
        ],
      });
    } else if (l.type === 'WMTS') {
      layerOpts.push({
        id: l.id,
        preview: l.preview,
        title: l.title,
        layers: [
          new M.layer.WMTS({
            url: l.url,
            name: l.name,
            legend: l.title,
            matrixSet: l.matrixSet,
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: l.format,
          }),
        ],
      });
    }
  });

  return new M.plugin.BackImgLayer({
    position: 'TR',
    layerId: 0,
    layerVisibility: true,
    collapsed: true,
    collapsible: true,
    columnsNumber: CONFIGURATIONS.background_layers_config.columns,
    layerOpts: layerOpts,
  });
}

const removeMapOverlays = () => {
  const overlays = mapjs.getMapImpl().getOverlays().getArray();
  overlays.forEach(item => {
    if (item.getKeys().indexOf('element') > -1 && item.element.innerHTML.indexOf('m-measure') < 0  && item.element.innerHTML.indexOf('ignsearchlocator') < 0) {
      mapjs.getMapImpl().removeOverlay(item);
    }
  });
}

const centerFeatures = (features) => {
  if (!M.utils.isNullOrEmpty(features)) {
    const extent = M.impl.utils.getFeaturesExtent(features);
    mapjs.getMapImpl().getView().fit(extent, {
      duration: 500,
      minResolution: 1,
    });
  }
}

const addVectorLayerFromFeatures = (layerName, features, type) => {
  if (type === 'uploaded') {
    layerName = 'uploadedLayer' + layerName;
  }

  const layer = new M.layer.Vector({ name: layerName }, { displayInLayerSwitcher: type === 'uploaded' ? true : false });
  layer.addFeatures(features);
  mapjs.addLayers(layer);
  layer.setZIndex(9999999999);
  return layer;
}

const convertToMFeatures = (features) => {
  if (features instanceof Array) {
    return features.map((olFeature) => {
      const feature = new M.Feature(olFeature.getId(), {
        geometry: {
          coordinates: olFeature.getGeometry().getCoordinates(),
          type: olFeature.getGeometry().getType(),
        },
        properties: olFeature.getProperties(),
      });

      feature.getImpl().getOLFeature().setStyle(olFeature.getStyle());
      return feature;
    });
  }
}

const loadGeoJSONLayer = (layerName, source) => {
  let features = new ol.format.GeoJSON().readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });

  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const loadKMLLayer = (layerName, source, extractStyles) => {
  let features = new ol.format.KML({ extractStyles }).readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });
  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const loadGPXLayer = (layerName, source) => {
  let features = new ol.format.GPX().readFeatures(source, { featureProjection: mapjs.getProjection().code });
  features.forEach((feature) => {
    const style1 = new ol.style.Style({
      stroke: new ol.style.Stroke({ color: '#0000FF', width: 8 }),
      fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.2)' }),
    });

    const style2 = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 24,
        stroke: new ol.style.Stroke({
          color: 'white',
          width: 2,
        }),
        fill: new ol.style.Fill({
          color: '#7CFC00',
        }),
      }),
    });

    if (feature.getGeometry().getType() !== 'Point' && feature.getGeometry().getType() !== 'MultiPoint') {
      feature.setStyle(style1);
    } else {
      feature.setStyle(style2);
    }
  });
  features = convertToMFeatures(features);
  let area = 0;
  features.forEach((f) => {
    if (Utils.stringContainsString(f.getGeometry().type, 'polygon')) {
      area += ol.extent.getArea(M.impl.utils.getFeaturesExtent([f]));
    }
  });

  if (features.length > 0 && features.length <= CONFIGURATIONS.num_features_allowed && area <= CONFIGURATIONS.max_area_allowed) {
    addVectorLayerFromFeatures(layerName, features, 'uploaded');
  }

  return features;
}

const controlDrawWithKeyboard = (draw, e) => {
  if (draw !== undefined && e !== undefined) {
    const key = e.keyCode || e.which;
    if (key === 27) {
      if (document.getElementById('drawPolygon').style.color === 'white') {
        document.getElementById('drawPolygon').click();
      }
    }

    if (key === 13) {
      draw.finishDrawing();
    }
  }
};

const showInfoPopup = (feature, t) => {
  removeMapOverlays();
  const overlay = new ol.Overlay({
    element: getInfoPopupContent(feature, t),
    stopEvent: true,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    },
    offset: [-10, 10],
    position: feature.getGeometry().getCoordinates(),
    positioning: 'top-right',
  });

  mapjs.getMapImpl().addOverlay(overlay);
  document.getElementById('overlay-close-button').addEventListener('click', removeMapOverlays);
};

const getInfoPopupContent = (feature, t) => {
  // const attributes = feature.getProperties().features[0].values_;
  const attributes = feature.getProperties();
  const attr = [];
  for (let key in attributes) {
    const label = getLabel(key, t);
    if (label.position !== undefined && attributes[key] !== undefined && attributes[key] !== null && attributes[key] !== '') {
      let value = attributes[key];
      if (key === 'fecha') {
        value = `${value.substring(6, value.length)}/${value.substring(4, 6)}/${value.substring(0, 4)}`;
      }

      attr[label.position] = <p class='popup-overlay-info-attr' key={key}><b>{label.name}:&nbsp;&nbsp;</b>{value}</p>;
    }
  }

  const htmlString = reactElementToJSXString(
    <div id='popup-overlay' class='popup-overlay-container'>
      <div class='popup-overlay-title'>
        {t('visor.photo') + ' (' + t('visor.aprox_position') + ')'}
        <button id='overlay-close-button' class='popup-overlay-close-button'>
          X
        </button>
      </div>
      <div class='popup-overlay-info-container'>
        <div>
          {attr}
        </div>
      </div>
    </div>
  );

  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  return doc.getElementById('popup-overlay');
}

const getLabel = (nameField, t) => {
  let name = nameField;
  let position = undefined;
  switch(nameField) {
    case 'fotogramas':
      name = t('visor.file');
      position = 0;
      break;
    case 'id_vuelo':
      name = t('visor.flight');
      position = 1;
      break;
    case 'fecha':
      name = t('visor.date');
      position = 3;
      break;
    case 'hoja':
      name = t('visor.sheet');
      position = 4;
      break;
    default:
      break;
  }

  return { name: name, position: position };
};
